import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import webLogin from '@utils/weblogin';
import videoService from '@services/videoService';
import CardHead from './cardHead';
import CardFollow from './cardFollow';
import CardDesc from './cardDesc';
import CardReport from './cardReport';
import CardTip from './cardTip';
export default {
  name: 'Card',
  props: {
    targetUid: String,
    anchorID: String,
    cardType: Number,
    top: String,
    left: String,
    isShowCard: Boolean,
    channelID: String
  },
  data: function data() {
    return {
      VideoAPIService: null,
      userInfo: null,
      countInfo: null,
      videoid: '',
      relationState: false,
      tipInfo: '',
      showReport: false
    };
  },
  watch: {
    targetUid: function targetUid(val) {
      if (val) {
        this.initData();
      }
    },
    anchorID: function anchorID(val) {
      if (val) {
        this.initData();
      }
    },
    immediate: true,
    deep: true
  },
  created: function created() {},
  mounted: function mounted() {
    this.VideoAPIService = videoService.createApi();
    if (this.targetUid || this.anchorID) {
      this.initData();
    }
  },
  components: {
    'card-head': CardHead,
    'card-follow': CardFollow,
    'card-desc': CardDesc,
    'card-report': CardReport,
    'card-tip': CardTip
  },
  methods: {
    initData: function initData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var authentication, _yield$_this$VideoAPI, user;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              authentication = webLogin.getAuthentication();
              if (!webLogin.checkLogin()) {
                _context.next = 6;
                break;
              }
              _this.VideoAPIService.getProfile(_this.targetUid || _this.anchorID, authentication).then(function (data) {
                _this.userInfo = data.user_info;
                _this.countInfo = data.count_info;
                _this.videoid = data.videoid;
                _this.relationState = _this.userInfo.is_relation === '50001' || _this.userInfo.is_relation === '50008';
              }).catch(function (e) {
                if (e.status === 200 && e.data && e.data.status === '402') {
                  webLogin.reset();
                  _this.$lmBus && _this.$lmBus.$emit('Header-Login-Out-Handle');
                }
              });
              _context.next = 14;
              break;
            case 6:
              _context.next = 8;
              return _this.VideoAPIService.getUserInfo(_this.targetUid || _this.anchorID);
            case 8:
              _yield$_this$VideoAPI = _context.sent;
              user = _yield$_this$VideoAPI.user;
              _this.userInfo = user.user_info;
              _this.countInfo = user.count_info;
              _this.videoid = user.videoid;
              _this.relationState = _this.userInfo.is_relation === '50001' || _this.userInfo.is_relation === '50008';
            case 14:
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 16]]);
      }))();
    },
    followUser: function followUser() {
      if (this.userInfo) {
        this.$emit('subscribeHandler', this.userInfo.uid, this.relationState, 4);
      }
    },
    closeCard: function closeCard() {
      this.$emit('closecard');
    },
    changeReport: function changeReport() {
      this.showReport = !this.showReport;
    },
    feedbackSend: function feedbackSend(content, desc) {
      var _this2 = this;
      var uinfo = webLogin.getUserInfoData();
      var param = _objectSpread({
        tuid: uinfo.user.uid,
        reportuid: this.targetUid || this.anchorID,
        type: this.cardType,
        content: content,
        desctext: desc,
        vid: this.channelID,
        androidid: uinfo.deviceid,
        token: uinfo.token,
        deviceid: uinfo.deviceid,
        thirdchannel: 6
      }, uinfo.user);
      this.VideoAPIService.feedbackSend(param).then(function () {
        _this2.changeReport();
        _this2.tipInfo = "".concat(_this2.$t('liveroom.personalCard.reportSucc'));
        setTimeout(function () {
          _this2.tipInfo = '';
        }, 1500);
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
};